import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatastoreModule } from './datastore/datastore.module';
import { ProviderModule } from './provider/provider.module';
import { BrevoConfigModule } from './brevo-config/brevo-config.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    DatastoreModule,
    ProviderModule,
    BrevoConfigModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [DatastoreModule]
})
export class SettingsModule { }
